<template>
    <span class="sensitive-word-item">
        <span
            ref="tmpSensitiveWord"
            class="tmpSensitiveWord"
        >{{ currentValue }}</span>
        <span
            v-if="mode == 'view'"
            class="sensitive-word-item--view"
        >
            <v-icon
                class="sensitive-word-item__icon-edit"
                name="edit_small"
                @click="edit"
            />
            <span class="sensitive-word-item-text">{{ value }}</span>
            <v-icon
                class="sensitive-word-item__icon-delete"
                name="delete_small"
                @click="remove"
            />
        </span>
        <span
            v-else
            class="sensitive-word-item--edit"
        >
            <v-input
                ref="keywordInput"
                v-model="currentValue"
                :maxlength="maxlength"
                :style="{ width: inputWidth + 'px', margin: 0 }"
                :clearable="false"
                @change="change"
                @enter="enter"
            />
            <v-icon
                v-if="canTick"
                class="sensitive-word-item__icon-tick"
                name="tick_small"
                @click="tick"
            />
            <v-icon
                class="sensitive-word-item__icon-cancel"
                name="cancel_small"
                @click="cancel"
            />
        </span>
    </span>
</template>

<script>
/* eslint-disable */

import { Icon } from 'vhtml-ui';

const sprites = require.context('./assets/icons', false, /[^\.]+\.svg$/);
Icon.addSprites(sprites);

const spaceFilterReg = /[\s\uFEFF\xA0]+/g;
const sensitiveWordFilterReg = /^[\u4e00-\u9fa5a-zA-Z0-9]+$/;

export default {
    name: 'KeywordItem',
    props: {
        value: {
            type: String,
            default: ''
        },
        idx: {
            type: [Number, String],
            default: -1
        },
        mode: {
            type: String,
            default: 'view'
        },
        maxlength: {
            type: Number,
            default: 4
        }
    },

    data() {
        return {
            currentValue: this.value,
            inputWidth: 70
        };
    },

    computed: {
        canTick() {
            let currentValue = this.currentValue || '';
            currentValue = currentValue.replace(spaceFilterReg, '');
            return currentValue.length > 0;
        }
    },

    watch: {
        mode(nextValue) {
            switch (nextValue) {
                case 'edit':
                    this.$nextTick(function() {
                        this.$refs.keywordInput.focus();
                    });
                    break;
                case 'view':
                    this.$nextTick(function() {
                        this.currentValue = this.value;
                    });
                    break;
                default:
                    console.log('undefined mode');
            }
        },
        currentValue(nextValue, oldValue) {
            this.$nextTick(function() {
                this.inputWidth = this.$refs.tmpSensitiveWord.offsetWidth + 11;
                if (nextValue != '' && !sensitiveWordFilterReg.test(nextValue)) {
                    this.currentValue = oldValue;
                }
            });
        }
    },

    mounted() {
        if (this.mode === 'edit') {
            this.$nextTick(() => {
                this.$refs.keywordInput.focus();
            });
            this.inputWidth = this.$refs.tmpSensitiveWord.offsetWidth + 11;
        }
    },

    methods: {
        edit() {
            this.$emit('input', 'edit', this.idx);
        },
        remove() {
            this.$emit('input', 'delete', this.idx);
        },
        tick() {
            this.$emit('input', 'tick', this.idx, this.currentValue);
        },
        change(nextValue) {
            this.currentValue = nextValue.replace(spaceFilterReg, '');
        },
        enter() {
            if (this.currentValue) {
                this.tick();
            } else {
                this.remove();
            }
        },
        cancel() {
            if (this.value == '') {
                this.$emit('input', 'delete', this.idx);
            } else {
                this.currentValue = this.value;
                this.$emit('input', 'tick', this.idx, this.value);
            }
        }
    }
};
</script>

<style lang="less">
.sensitive-word-item {
    position: relative;
    display: inline-block;
    vertical-align: middle;
    .tmpSensitiveWord {
        position: absolute;
        top: -9999px;
        left: -9999px;
        font-size: 14px;
        font-family: 'Microsoft YaHei UI';
        font-weight: 400;
        letter-spacing: 0px;
        text-transform: none;
        white-space: nowrap;
    }
    &--edit,
    &--view {
        position: relative;
        display: inline-block;
        box-sizing: border-box;
        // background-color: #e4e8ea;
        border: 1px solid rgba(17, 32, 70, 0.13);
        border-radius: 3px;
        // border-radius: 15px;
        padding: 0 32px;
        margin: 0 10px 0 0;
        height: 32px;
    }

    &--edit {
        padding: 0 50px 0 30px;
        .sensitive-word-item__icon-tick {
            right: 28px;
            top: 7px;
            color: #00cc26;
            &:hover {
                color: #01b022;
            }
        }
        .sensitive-word-item__icon-cancel {
            right: 8px;
            top: 7px;
        }
    }

    &--view {
        &:hover {
            svg {
                visibility: visible;
            }
        }
        svg {
            visibility: hidden;
        }
        .sensitive-word-item__icon-edit {
            left: 8px;
            top: 7px;
        }
        .sensitive-word-item__icon-delete {
            right: 8px;
            top: 7px;
        }
    }

    &--edit {
        .v-input--default {
            height: 30px;
            border: none;
            border-radius: 0;
            padding: 0;
            background: none;
            .v-input--main {
                margin: 0;
            }
            .v-input--default__input {
                width: 100%;
                height: 30px;
                line-height: 30px;
                padding: 0;
            }
        }
    }

    .sensitive-word-item-text {
        line-height: 30px;
        vertical-align: middle;
        cursor: default;
        margin-right: 4px;
    }

    svg {
        position: absolute;
        padding: 0 2px;
        color: #aeb1b8;
        width: 16px;
        height: 16px;
        cursor: pointer;
        vertical-align: middle;
        &:hover {
            color: #1e2330;
        }
    }
}
</style>
